'use client';

import { Button } from '@/components/ui/button';
import { requestPasswordUpdate } from '@/utils/auth-helpers/server';
import { useState } from 'react';
import { handleSimpleResponse } from '@/utils/helpers';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

// Define prop type with allowEmail boolean
interface ForgotPasswordProps {
  allowEmail: boolean;
  redirectMethod: string;
}

export default function ForgotPassword({
  allowEmail,
  redirectMethod
}: ForgotPasswordProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true); // Disable the button while the request is being handled
    const res = await requestPasswordUpdate(new FormData(e.currentTarget));
    handleSimpleResponse(res);
    setIsSubmitting(false);
  };

  return (
    <form
      noValidate={true}
      className="mb-4 grid"
      onSubmit={(e) => handleSubmit(e)}
    >
      <Label htmlFor="email">Email</Label>
      <Input
        id="email"
        placeholder="name@example.com"
        type="email"
        name="email"
        autoCapitalize="none"
        autoComplete="email"
        autoCorrect="off"
        className="bg-gray-200"
      />
      <Button type="submit" className="mt-4">
        Send Email
      </Button>
    </form>
  );
}
